<footer
  class="flex flex-col items-center space-y-[24px] px-[60px] pb-[calc(70px-env(safe-area-inset-bottom))] pt-[16px]"
>
  <slot />
</footer>
